export enum LeaderboardResultType {
  PROMOTED = 'PROMOTED',
  DEMOTED = 'DEMOTED',
  REMAINED = 'REMAINED',
}



// WEBPACK FOOTER //
// ./ts/app/shared/types/leaderboard-result-type.ts